import { StripeElementsOptions } from '@stripe/stripe-js';

export const CStripeOptions: StripeElementsOptions = {
  currency: 'usd',
  loader: 'always',
  capture_method: 'manual',
  mode: 'setup',
  paymentMethodCreation: 'manual',
  payment_method_types: ['card'],
  setup_future_usage: 'off_session',
  appearance: {
    theme: 'stripe',
    variables: {
      borderRadius: '10px',
    },
    rules: {
      '.Label': {
        fontSize: '0px'
      },
      '.Input': {
        padding: '15px 16px'
      }
    }
  }
};

export const minBrowsersSupport = {
  chrome: 88,
  firefox: 78,
  safari: 14,
  opera: 79,
  edge: 88,
}
